var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"newsBox"},[_c('div',{staticClass:"newsTitle"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"newsDetail",domProps:{"innerHTML":_vm._s(_vm.htmlCon)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }